import React from "react"
import styled, { css } from "styled-components"
import Checked from "../../assets/svg/checked.svg"
import ErrorIcon from "../../assets/svg/warning.svg"

const StyledAlert = styled.div`
  display: flex;
  background: ${({ bg, theme }) => theme[bg]};
  border-radius: 5px;
  padding: 10px;
  width: 300px;
  position: fixed;
  top: 6em;
  justify-content: center;
  z-index: 1;
  ${({ isOpen }) =>
    isOpen
      ? css`
          right: 10px;
          opacity: 1;
        `
      : css`
          right: -400px;
          opacity: 0;
        `};
  transition: all 0.3s ease;
  p {
    letter-spacing: 0.01071em;
    color: ${({ theme: { white } }) => white};
    font-weight: 500;
    font-size: 0.875rem;
  }
  @media only screen and (max-width: 970px) {
    position: fixed;
  }

  svg {
    width: 20px;
    fill: ${({ theme: { white } }) => white};
    margin-right: 10px;
  }
`

const SuccessAlert = (message, alert) => {
  return (
    <StyledAlert isOpen={alert} bg="success">
      <Checked />
      <p>{message}</p>
    </StyledAlert>
  )
}

const ErrorAlert = (message, alert) => {
  return (
    <StyledAlert isOpen={alert} bg="error">
      <ErrorIcon />
      <p>{message}</p>
    </StyledAlert>
  )
}

const Alert = ({ message, type, alert }) => {
  const AlertTypes = {
    success: SuccessAlert,
    error: ErrorAlert,
  }
  return <>{AlertTypes[type.length ? type : "success"](message, alert)}</>
}

export default Alert
